import React from 'react'

import { faEdit } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { PageTitle } from '@scoir/headers'
import PropTypes from 'prop-types'

import CurrentUpcomingAppCycleToggle from 'routes/application/CurrentUpcomingAppCycleToggle'

const useStyles = makeStyles((theme) => ({
  cancelBtn: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
  },
  header: {
    [theme.breakpoints.down('xs')]: {
      wordBreak: 'break-all',
    },
  },
}))

const Header = ({
  canEdit,
  isEditing,
  onIsEditingToggle,
  onSave,
  isSaving,
  isError,
  setFormErrors,
  loading,
  canChangeAppCycle,
  appCycle,
  isCurrentAppCycle,
  onChangeAppCycle,
}) => {
  const classes = useStyles()

  return (
    <>
      <Box>
        <PageTitle
          title={`Configure Application`}
          titleProps={{ className: classes.header }}
          actions={
            canChangeAppCycle && (
              <CurrentUpcomingAppCycleToggle
                hasCurrentFocus={isCurrentAppCycle}
                onChangeCycleFocus={onChangeAppCycle}
              />
            )
          }
        />
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        flexWrap="wrap"
        justifyContent="space-between"
        alignItems="center"
        gridGap={16}
      >
        <Typography
          variant="h6"
          component="h2"
        >
          {appCycle - 1}-{appCycle} Application
        </Typography>
        {!loading && canEdit && (
          <Box
            display="flex"
            flexWrap="wrap"
            gridGap={8}
          >
            {canEdit && (
              <>
                {!isEditing && (
                  <Box>
                    <Button
                      color="primary"
                      onClick={() => onIsEditingToggle(true)}
                      disabled={isSaving}
                      startIcon={<FontAwesomeIcon icon={faEdit} />}
                    >
                      Edit Configuration
                    </Button>
                  </Box>
                )}
                {isEditing && (
                  <Box
                    display="flex"
                    flexWrap="wrap"
                    gridGap={8}
                  >
                    <Button
                      color="primary"
                      variant="outlined"
                      onClick={() => {
                        onIsEditingToggle(false)
                        setFormErrors({})
                      }}
                      className={classes.cancelBtn}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      onClick={onSave}
                      disabled={isSaving || isError}
                    >
                      {isSaving ? 'Saving...' : 'Save Changes'}
                    </Button>
                  </Box>
                )}
              </>
            )}
          </Box>
        )}
      </Box>
    </>
  )
}

Header.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
  onIsEditingToggle: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
  setFormErrors: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  configurationId: PropTypes.string,
  canChangeAppCycle: PropTypes.bool.isRequired,
}

export default Header
